/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Offer_HintInputs */

const en_us2_gallery_offer_hint = /** @type {(inputs: Gallery_Offer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No one's names or details. The team reviews it before publishing.`)
};

const pt_br2_gallery_offer_hint = /** @type {(inputs: Gallery_Offer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem nomes ou dados de ninguém. A equipe revisa antes de publicar.`)
};

const pt_pt2_gallery_offer_hint = /** @type {(inputs: Gallery_Offer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem nomes ou dados de ninguém. A equipe revisa antes de publicar.`)
};

/** @type {(inputs: Gallery_Offer_HintInputs) => LocalizedString} */
const es_419_gallery_offer_hint = en_us2_gallery_offer_hint;

/** @type {(inputs: Gallery_Offer_HintInputs) => LocalizedString} */
const fr_fr2_gallery_offer_hint = en_us2_gallery_offer_hint;

/** @type {(inputs: Gallery_Offer_HintInputs) => LocalizedString} */
const de_de2_gallery_offer_hint = en_us2_gallery_offer_hint;

/** @type {(inputs: Gallery_Offer_HintInputs) => LocalizedString} */
const it_it2_gallery_offer_hint = en_us2_gallery_offer_hint;

/**
* | output |
* | --- |
* | "No one's names or details. The team reviews it before publishing." |
*
* @param {Gallery_Offer_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_offer_hint = /** @type {((inputs?: Gallery_Offer_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Offer_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_offer_hint(inputs)
	if (locale === "es-419") return es_419_gallery_offer_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_offer_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_offer_hint(inputs)
	if (locale === "de-DE") return de_de2_gallery_offer_hint(inputs)
	if (locale === "it-IT") return it_it2_gallery_offer_hint(inputs)
	return en_us2_gallery_offer_hint(inputs)
});
export { gallery_offer_hint as "gallery.offer_hint" }